export default {
	home: {
		// 游戏分类标题
		afunOriginals: "AFun Originals",
		slots: "Slots",
		liveCasino: "Live Casino",
		casualGames: "Casual Games",
		newReleases: "New Releases",

		// 三大入口
		casinoTitle: "Casino",
		casinoDesc: "Enjoy casino games with thousands of slots, live dealers, and table games",
		goToCasino: "Go to Casino",
		sportsTitle: "Sports",
		sportsDesc: "Bet on Football, Basketball, Tennis and more sports with the best odds",
		goToSports: "Go to Sports",
		liveTitle: "Live",
		liveDesc: "Real-time action with live dealers and interactive gaming experience",
		goToLive: "Go to Live",

		// Latest Bet & Race
		latestBetRace: "Latest Bet & Race",
		sports: "Sports",
		latestBets: "Latest Bets",
		game: "Game",
		player: "Player",
		bet: "Bet",
		multiplier: "Multiplier",
		profit: "Profit",

		// Top 10
		top10Games: "Top 10 Games",

		// VIP 卡片
		vipClub: "VIP Club",
		details: "Details",
		progressToVip: "{percent}% to VIP {level}",
		vipMax: "VIP MAX",

		// VIP Details 弹窗
		vipDetailsTitle: "VIP Level & Benefits",
		vipColLevel: "Level",
		vipColRecharge: "Recharge",
		vipColBets: "Bets",
		vipColRequired: "Required",
		vipColLevelUpBonus: "Level up bonus",
		vipColDailyRakeback: "Daily Rakeback",
		vipColWeeklyLossback: "Weekly Lossback",
		vipColMonthlyRakeback: "Monthly Rakeback",
		vipRequiredRecharge: "Recharge",
		vipRequiredBets: "Bets",
		vip: "VIP",
		rewards: "Rewards",
		affiliate: "Affiliate",
		promotion: "Promotion",
		
	},

	latestBetRace: {
		title: "Game Leaderboard Grand Prix",
		playerBetRank: "Today's Player Bets",
		playerWinRank: "Today's Player Wins",
		gameBetRank: "Today's Game Bets",
		gameWinRank: "Today's Game Returns",
		player: "Player",
		game: "Game",
		bet: "Bet",
		profit: "Win",
		ratio: "Payout Ratio",
		totalBet: "Total Bet",
		totalReturn: "Total Return",
		maxBet: "Max Bet",
		gameRatio: "Return %",
		noData: "No Data Available",
	},

	GameClassify: {
		casinoTitle: "Casino",
		casinoDesc: "Enjoy casino games from top providers",
		casinoBtn: "Go to Casino",
		sportsTitle: "Sports",
		sportsDesc: "Bet on Football, Cricket, NFL, eSports & over 80 sports",
		sportsBtn: "Go to Sports",
		liveTitle: "Live",
		liveDesc: "Real-time action with live dealers",
		liveBtn: "Go to Live"
	},
	
	NewTop10Game:{
		
	}
}